var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeviceModel24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "model-device-name__Type=Model device name",
    className: "model-device-name__Type=Model model-device-name__device model-device-name__name"
  }, /*#__PURE__*/React.createElement("g", {
    id: "model-device-name__Vector",
    className: "model-device-name__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212B36",
    d: "M20 20.004v1.5H4v-1.5h16Zm1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5H4a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5v1.5l-.154-.004a3 3 0 0 1-2.842-2.842L1 18.504v-12a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12l-.004.154a3 3 0 0 1-2.842 2.842l-.154.004v-1.5a1.5 1.5 0 0 0 1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212B36",
    d: "M10.133 10.21a.242.242 0 0 0-.242-.242H6.54a.242.242 0 0 0-.242.241v4.59l.005.048c.022.11.12.193.237.193h3.352a.242.242 0 0 0 .242-.242V10.21Zm8.296 4.83a.726.726 0 0 1 0 1.451H16.59a.725.725 0 1 1 0-1.45h1.838Zm-.001-3.275a.726.726 0 0 1 0 1.451H14.34a.725.725 0 0 1 0-1.45h4.088Zm0-3.248a.726.726 0 0 1 0 1.45H14.34a.725.725 0 0 1 0-1.45h4.088Zm-6.844 6.281c0 .935-.758 1.693-1.693 1.693H6.54a1.693 1.693 0 0 1-1.684-1.519l-.009-.174V10.21c0-.934.758-1.692 1.693-1.692h3.352c.935 0 1.693.758 1.693 1.692v4.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceModel24);
export default __webpack_public_path__ + "static/media/icon_device_model_24.ba9be8afd1a7a3991aed3c76542774fe.svg";
export { ForwardRef as ReactComponent };